import { NotificationBanner } from '@chegg-ui/notification-banner'
import { colors, font, spacing } from '@chegg-ui/theme'
import styled from 'styled-components'

export const Toast = styled(NotificationBanner)`
  border-radius: ${spacing.px8};
  width: 374px;

  [data-test^='notif-message-toast-message-'] {
    display: inline;
  }

  #toast-link {
    cursor: pointer;
    color: ${colors.grey900};
    font-size: ${font.size.px14};
    letter-spacing: 0.25px;
    text-decoration-line: underline;
  }
`
